import React from 'react';

import {
  Box as MuiBox,
  BoxProps as MuiBoxProps,
  makeStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  pageContentStyle: {
    boxSizing: 'border-box',
    margin: 'auto',
    maxWidth: 1366,
  },
}));

interface PageProps {
  children: React.ReactNode;
}

const Page = ({
  children,
  className = '',
  ...rest
}: PageProps & MuiBoxProps) => {
  const classes = useStyles();

  return (
    <MuiBox className={`${className}`} {...rest}>
      <MuiBox className={classes.pageContentStyle}>{children}</MuiBox>
    </MuiBox>
  );
};

export default Page;
